"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var FormError_1 = require("./FormError");

var FormLabel_1 = require("./FormLabel");

function FormControl(props) {
  var children = props.children,
      id = props.id,
      name = props.name,
      error = props.error,
      label = props.label,
      required = props.required;
  var styles = {
    label: {
      display: 'block',
      marginBottom: '0.25rem',
      lineHeight: '20px'
    },
    error: {
      marginTop: '0.25rem',
      lineHeight: '20px'
    }
  };
  return react_1.default.createElement("div", {
    "data-name": name
  }, label && react_1.default.createElement(FormLabel_1.FormLabel, {
    required: required,
    style: styles.label,
    htmlFor: id,
    label: label
  }), children, error && react_1.default.createElement(FormError_1.FormError, {
    style: styles.error
  }, error));
}

exports.FormControl = FormControl;